var _defs, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedTemplateIcon(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st2, .st6, .st5 {\n        stroke: #29e67c;\n      }\n\n      .st0, .st6, .st7, .st3, .st4, .st5 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st3, .st4, .st5 {\n        stroke-width: 1.5px;\n      }\n\n      .st0, .st4 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke: #69707b;\n      }\n\n      .st1, .st2, .st6, .st7 {\n        stroke-width: 2px;\n      }\n\n      .st1, .st2, .st6, .st7, .st8 {\n        fill: #fff;\n      }\n\n      .st6, .st7 {\n        stroke-linejoin: round;\n      }\n\n      .st7, .st3, .st4 {\n        stroke: #707070;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "template"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64410",
    className: "st8",
    d: "M-115.81,90c0,2.21-1.79,4-4,4h-58c-2.21,0-4-1.79-4-4V26c0-2.21,1.79-4,4-4h58c2.21,0,4,1.79,4,4v64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64413",
    className: "st1",
    d: "M-115.81,90c0,2.21-1.79,4-4,4h-58c-2.21,0-4-1.79-4-4V26c0-2.21,1.79-4,4-4h58c2.21,0,4,1.79,4,4v64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64414",
    className: "st3",
    d: "M-125.81,70h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64415",
    className: "st3",
    d: "M-125.81,77h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64416",
    className: "st8",
    d: "M-88.81,90c0,2.21-1.79,4-4,4h-61c-2.21,0-4-1.79-4-4V5c0-2.21,1.79-4,4-4h61c2.21,0,4,1.79,4,4v85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64412",
    className: "st4",
    d: "M-168.81,39h22v21h-22v-21Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_104762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64417",
    className: "st7",
    d: "M-88.81,44v46c0,2.21-1.79,4-4,4h-61c-2.21,0-4-1.79-4-4V5c0-2.21,1.79-4,4-4h61c2.21,0,4,1.79,4,4v31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64418",
    className: "st3",
    d: "M-101.81,33h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64419",
    className: "st3",
    d: "M-101.81,40h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64420",
    className: "st3",
    d: "M-101.81,47h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64421",
    className: "st3",
    d: "M-101.81,54h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64422",
    className: "st3",
    d: "M-101.81,61h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64423",
    className: "st3",
    d: "M-101.81,68h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64424",
    className: "st3",
    d: "M-101.81,75h-43"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64425",
    className: "st8",
    d: "M-67.81,90c0,2.21-1.79,4-4,4h-60c-2.21,0-4-1.79-4-4v-42c0-2.21,1.79-4,4-4h60c2.21,0,4,1.79,4,4v42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64427",
    className: "st4",
    d: "M-144.81,18h15v8h-15v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64428",
    className: "st1",
    d: "M-67.81,90c0,2.21-1.79,4-4,4h-60c-2.21,0-4-1.79-4-4v-42c0-2.21,1.79-4,4-4h60c2.21,0,4,1.79,4,4v42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64430",
    className: "st4",
    d: "M-93.81,56h15v8h-15v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64431",
    className: "st3",
    d: "M-100.81,72h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64432",
    className: "st3",
    d: "M-100.81,77h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64433",
    className: "st3",
    d: "M-100.81,82h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64434",
    className: "st3",
    d: "M-101.81,18h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64435",
    className: "st3",
    d: "M-101.81,25h-21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "template1",
    "data-name": "template"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_644101",
    "data-name": "Path_64410",
    className: "st8",
    d: "M67,89.93c0,2.19-1.79,3.97-4,3.97H5c-2.21,0-4-1.78-4-3.97V26.34c0-2.19,1.79-3.97,4-3.97h58c2.21,0,4,1.78,4,3.97v63.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644131",
    "data-name": "Path_64413",
    className: "st2",
    d: "M67,89.93c0,2.19-1.79,3.97-4,3.97H5c-2.21,0-4-1.78-4-3.97V26.34c0-2.19,1.79-3.97,4-3.97h58c2.21,0,4,1.78,4,3.97v63.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644141",
    "data-name": "Path_64414",
    className: "st5",
    d: "M57,70.05H14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644151",
    "data-name": "Path_64415",
    className: "st5",
    d: "M57,77.01H14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644161",
    "data-name": "Path_64416",
    className: "st8",
    d: "M94,89.93c0,2.19-1.79,3.97-4,3.97H29c-2.21,0-4-1.78-4-3.97V5.47c0-2.19,1.79-3.97,4-3.97h61c2.21,0,4,1.78,4,3.97v84.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644121",
    "data-name": "Path_64412",
    className: "st0",
    d: "M14,39.25h22v20.86H14v-20.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047621",
    "data-name": "Group_104762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_644171",
    "data-name": "Path_64417",
    className: "st6",
    d: "M94,44.22v45.7c0,2.19-1.79,3.97-4,3.97H29c-2.21,0-4-1.78-4-3.97V5.47c0-2.19,1.79-3.97,4-3.97h61c2.21,0,4,1.78,4,3.97v30.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644181",
    "data-name": "Path_64418",
    className: "st5",
    d: "M81,33.29h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644191",
    "data-name": "Path_64419",
    className: "st5",
    d: "M81,40.25h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644201",
    "data-name": "Path_64420",
    className: "st5",
    d: "M81,47.2h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644211",
    "data-name": "Path_64421",
    className: "st5",
    d: "M81,54.16h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644221",
    "data-name": "Path_64422",
    className: "st5",
    d: "M81,61.11h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644231",
    "data-name": "Path_64423",
    className: "st5",
    d: "M81,68.07h-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644241",
    "data-name": "Path_64424",
    className: "st5",
    d: "M81,75.02h-43"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_644251",
    "data-name": "Path_64425",
    className: "st8",
    d: "M115,89.93c0,2.19-1.79,3.97-4,3.97h-60c-2.21,0-4-1.78-4-3.97v-41.73c0-2.19,1.79-3.97,4-3.97h60c2.21,0,4,1.78,4,3.97v41.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644271",
    "data-name": "Path_64427",
    className: "st0",
    d: "M38,18.39h15v7.95h-15v-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644281",
    "data-name": "Path_64428",
    className: "st2",
    d: "M115,89.93c0,2.19-1.79,3.97-4,3.97h-60c-2.21,0-4-1.78-4-3.97v-41.73c0-2.19,1.79-3.97,4-3.97h60c2.21,0,4,1.78,4,3.97v41.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644301",
    "data-name": "Path_64430",
    className: "st0",
    d: "M89,56.15h15v7.95h-15v-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644311",
    "data-name": "Path_64431",
    className: "st5",
    d: "M82,72.04h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644321",
    "data-name": "Path_64432",
    className: "st5",
    d: "M82,77.01h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644331",
    "data-name": "Path_64433",
    className: "st5",
    d: "M82,81.98h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644341",
    "data-name": "Path_64434",
    className: "st5",
    d: "M81,18.39h-21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644351",
    "data-name": "Path_64435",
    className: "st5",
    d: "M81,25.35h-21"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedTemplateIcon);
export default __webpack_public_path__ + "static/media/SelectedTemplateIcon.ea5ef5da38213c964d46faba2ac46039.svg";
export { ForwardRef as ReactComponent };